import Highcharts from 'highcharts';

export const figure14 = {
chart: {
zoomType: 'xy',
animation: false,
marginTop: 50,
marginLeft: 270,
plotBackgroundColor: null,
plotBorderWidth: null,
plotShadow: false,
type: 'bar',
height: '600px',
backgroundColor: 'rgba(255, 255, 255, 0.0)',
style: {
fontFamily: 'Montserrat'
}
},

colors: ['#ffc000', '#fff3cd','#ffd653'],

credits: {
enabled: false
},
title: {
text: null
},
subtitle: {
text: null
},

plotOptions: {
series: {
borderWidth: 0,
marker: {
symbol: 'circle',
enabled: false,
states: {
hover: {
enabled: true,
radius: 5
}
}
}
}
},

exporting: {
enabled: false
},

xAxis: [{
reversed: true,
categories: [ "العالم", "", "آسيا الوسطى وجنوب آسيا", "أفريقيا جنوب الصحراء", "شمال أفريقيا وغرب آسيا", "أمريكا اللاتينية ومنطقة البحر الكاريبي", "شرق آسيا وجنوب شرق آسيا", "أوقيانوسيا ", "أوروبا وأمريكا الشمالية", "أستراليا ونيوزيلندا" ],
lineColor: "#d7d7d7",
tickColor: "#d7d7d7",
tickLength: 16,
labels: {
style: {
fontWeight: 'normal',
color: '#999999',
fontSize: '12px'
}
},
}],
yAxis: [{
labels: {
format: '{value}',
style: {
fontWeight: 'normal',
color: '#999999',
fontSize: '12px'
},
},
max: 60,
min: 0,
tickInterval: 10,
gridLineWidth: 2,
title: {
text: 'النسبة المئوية',
style: {
color: Highcharts.getOptions().colors[1]
}
}
}],
tooltip: {
shared: true,
useHTML: true,
hideDelay: 500,
backgroundColor: null,
borderWidth: 0,
shadow: false,
style: {
padding: 0
}
},
legend: {
enabled: false,
},

series: [      
{
name: '2000',
tooltip: {
valueSuffix: '%'
},
dataLabels: {
enabled: false,
formatter: function () {
     return Highcharts.numberFormat(this.y, 1);
},
style: {
     fontWeight: 'normal',
     textOutline: false,
     color: '#999999',
     fontSize: '10px'
}
},
data: [31.2, null, 49.0, 46.8, 36.7, 25.6, 24.5, 14.6, 13.2, 8.0],
},
{
name: '2015',
tooltip: {
valueSuffix: '%'
},
dataLabels: {
enabled: false,
style: {
     fontWeight: 'normal',
     textOutline: false,
     color: '#999999',
     fontSize: '10px'
}
},
data: [28.8, null, 47.1, 40.7, 31.4, 17.3, 18.4, 14.8, 13.5, 7.8],
},
{
name: '2019',
tooltip: {
valueSuffix: '%'
},
dataLabels: {
enabled: false,
style: {
fontWeight: 'normal',
textOutline: false,
color: '#999999',
fontSize: '10px'
}
},
data: [29.9, null, 47.5, 40.7, 31.8, 17.2, 19.5, 16, 14.6, 8.8],
},
]
}
